import React from "react";
import SearchDesktop$ from "@deosite/components-new/SearchDesktop";
import InputSecondary from "../formControls/input/InputSecondary";

const SearchDesktop = props => {
  const propsExt = {
    ...props,
    inputSecondary: <InputSecondary sx={{ width: 250, color: "main" }} />
  };
  return <SearchDesktop$ {...propsExt} />;
};

export default SearchDesktop;
